import { render, staticRenderFns } from "./alert.vue?vue&type=template&id=710a5c22"
import script from "./alert.vue?vue&type=script&lang=ts"
export * from "./alert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports